import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge, Input, Button } from 'reactstrap'
import { saveOrgMapping } from '../actions/threatlockerReconActions'

const UnmappedOrgsModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch()
  const unmappedOrgs = useSelector((state) => state.threatlockerRecon.unmappedOrgs)
  const companyLabels = useSelector((state) => state.threatlockerRecon.companyLabels)
  const [mappingState, setMappingState] = useState({})

  const getState = (id) => mappingState[id] || { companyId: '', searchText: '' }

  const updateState = (id, updates) => {
    setMappingState((prev) => ({ ...prev, [id]: { ...getState(id), ...updates } }))
  }

  const handleMap = (org) => {
    const state = getState(org.identifier)
    if (!state.companyId) return

    dispatch(saveOrgMapping(org.identifier, state.companyId))
    setMappingState((prev) => {
      const next = { ...prev }
      delete next[org.identifier]
      return next
    })
  }

  const getFilteredLabels = (searchText) => {
    if (!searchText) return []
    return (companyLabels || []).filter((c) =>
      c.label?.toLowerCase().includes(searchText.toLowerCase())
    ).slice(0, 10)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Unmapped Threatlocker Organizations
      </ModalHeader>
      <ModalBody>
        {(!unmappedOrgs || unmappedOrgs.length === 0) ? (
          <p className="text-muted">All synced Threatlocker organizations are mapped.</p>
        ) : (
          <p className="text-muted small mb-3">
            These Threatlocker organizations were found during sync but don't match any ConnectWise company.
            Map each one to a CW company to include it in reconciliation.
          </p>
        )}

        {(unmappedOrgs || []).map((org) => {
          const state = getState(org.identifier)
          const filtered = getFilteredLabels(state.searchText)

          return (
            <div key={org.identifier} className="border rounded p-3 mb-2">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>{org.displayName}</strong>
                  <Badge color="secondary" className="ms-2">{org.computerCount} devices</Badge>
                </div>
              </div>
              <div className="d-flex gap-2">
                <div style={{ flex: 1, position: 'relative' }}>
                  <Input
                    type="text"
                    placeholder="Search ConnectWise companies..."
                    value={state.searchText}
                    onChange={(e) => updateState(org.identifier, { searchText: e.target.value, companyId: '' })}
                    bsSize="sm"
                  />
                  {state.searchText && !state.companyId && filtered.length > 0 && (
                    <div
                      className="border rounded bg-white shadow-sm"
                      style={{ position: 'absolute', zIndex: 10, width: '100%', maxHeight: '150px', overflowY: 'auto' }}
                    >
                      {filtered.map((c) => (
                        <div
                          key={c.value}
                          className="p-2 border-bottom"
                          style={{ cursor: 'pointer' }}
                          onClick={() => updateState(org.identifier, { companyId: c.value, searchText: c.label })}
                        >
                          <small>{c.label}</small>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <Button
                  size="sm"
                  color="primary"
                  disabled={!state.companyId}
                  onClick={() => handleMap(org)}
                >
                  Map
                </Button>
              </div>
            </div>
          )
        })}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  )
}

export default UnmappedOrgsModal
